import { createStore } from 'vuex'

var URL = 'https://server-web.konaweselatankab.go.id/';
var URLS = 'https://dpupr.konaweselatankab.go.id/';

var UNIT = 'CqAcYavXFncBe88WG';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url : {
      URL : URLS,
      URL_APP : URL,
      URL_SLIDER : URL + 'api/v1/publish_pupr_slider/',
      URL_SAMBUTAN : URL + 'api/v1/publish_pupr_sambutan/',
      URL_BERITA : URL + 'api/v1/web_publish_berita/',
      URL_FOTO : URL + 'api/v1/publish_pupr_foto/',
      URL_VIDEO : URL + 'api/v1/publish_pupr_video/',
      URL_LINK : URL + 'api/v1/web_publish_link_terkait/',
      URL_PROFIL : URL + 'api/v1/publish_pupr_tentang/',
      URL_TUPOKSI : URL + 'api/v1/publish_pupr_tupoksi/',
      URL_STRUKTUR : URL + 'api/v1/publish_pupr_struktur_organisasi/',
      URL_VISI : URL + 'api/v1/publish_pupr_visi_misi/',
      URL_PEJABAT : URL + 'api/v1/publish_pupr_profil_pejabat/',
      URL_BERITA : URL + 'api/v1/web_publish_berita/',
      URL_PENGUMUMAN : URL + 'api/v1/publish_pupr_pengumuman/',
      URL_CIPTA_KARYA : URL + 'api/v1/publish_pupr_cipta_karya/',
      URL_BINA_MARGA : URL + 'api/v1/publish_pupr_bina_marga/',
      URL_SDA : URL + 'api/v1/publish_pupr_sumber_daya_air/',
      URL_JASA_KONSTRUKSI : URL + 'api/v1/publish_pupr_jasa_konstruksi/',
      URL_TATA_RUANG : URL + 'api/v1/publish_pupr_tata_ruang/',
      URL_DOKUMEN : URL + 'api/v1/publish_pupr_data_dokumen/',
      URL_FOTO : URL + 'api/v1/publish_pupr_foto/',
      URL_VIDEO : URL + 'api/v1/publish_pupr_video/',
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
